import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';

@Pipe({
  name: 'updateFinder'
})
export class UpdateFinderPipe implements PipeTransform {

  transform(updatedAt: Date): string {
    const DIFF = dayjs(new Date()).diff(updatedAt, 'minute');
    console.log(DIFF);

    const MINUTE = Math.floor(DIFF % 60);
    let hour = DIFF > 60 ? Math.floor(DIFF / 60) : 0;
    const DAY = hour > 24 ? Math.floor(hour / 24) : 0;

    if (DAY > 0) {
      hour = hour % 24;
    }

    const TEXT = `${DAY > 0 ? `${DAY} Days` : ''} ${hour > 0 ? `${hour} Hours` : ''} ${MINUTE > 1 ? `${MINUTE} Minutes` : 'Few Seconds'}`;
    return TEXT;
  }

}
